module.exports = __webpack_public_path__ + "static/img/solutionDetailPic32.e67a77a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionDetailPic32.png
// module id = zBxl
// module chunks = 1